/* eslint-disable */

export const saveOrderPair = {
    SAVE_ORDER_PAIR_REQUEST: 'SAVE_ORDER_PAIR_REQUEST',
    SAVE_ORDER_PAIR_SUCCESS: 'SAVE_ORDER_PAIR_SUCCESS',
    SAVE_ORDER_PAIR_FAILURE: 'SAVE_ORDER_PAIR_FAILURE',
};
